import { Products } from 'merchandise-lib/constants/Product';
import * as BundleTypes from 'self-service-api/constants/BundleTypes';
import * as ProductLevels from 'self-service-api/constants/ProductLevels';
import { ENTERPRISE, STARTER, tabIdToProductLevels } from '../../v2/constants/Tabs';
const tabIdToSuiteApiNameMap = {
  [STARTER]: [Products.HUBSPOT_FREE, Products.CRM_SUITE_STARTER_BUNDLE, Products.CRM_SUITE_PROFESSIONAL_BUNDLE],
  [ENTERPRISE]: [Products.CRM_SUITE_PROFESSIONAL_BUNDLE, Products.CRM_SUITE_ENTERPRISE_BUNDLE]
};
export const getMerchCardsToShow = ({
  tab
}) => {
  return tab ? tabIdToProductLevels[tab] : ['STARTER', 'PROFESSIONAL', 'ENTERPRISE'];
};
export const getMobileMerchCardsToShow = bundleType => {
  switch (bundleType) {
    case BundleTypes.NONE:
      return [];
    case BundleTypes.CRM_SUITE:
      return [ProductLevels.FREE, ProductLevels.STARTER, ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE];
    case BundleTypes.MARKETING_PLUS_SUITE:
      return [ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE];
    default:
      {
        return [ProductLevels.FREE, ProductLevels.STARTER, ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE];
      }
  }
};
export const getApiNamesToShowForBundle = ({
  bundleType,
  tab
}) => {
  switch (bundleType) {
    case BundleTypes.CRM_SUITE:
      return tab ? tabIdToSuiteApiNameMap[tab] : [Products.CRM_SUITE_STARTER_BUNDLE, Products.CRM_SUITE_PROFESSIONAL_BUNDLE, Products.CRM_SUITE_ENTERPRISE_BUNDLE];
    case BundleTypes.NONE:
    default:
      return [];
  }
};